/**
 * Central source of left navigation modules and sub-items.
 * It owns labels, tooltips, icon keys, and route placeholders for future navigation wiring.
 */
import { ROUTE_ROOTS } from '../models';
import { LeftNavItem } from '../models/left-nav-item.model';

const platformRoute = (segment: string): string => `/${ROUTE_ROOTS.PLATFORM}/${segment}`;

export const LEFT_NAV_ITEMS: LeftNavItem[] = [
    {
        id: 'dashboard',
        label: 'Dashboard',
        tooltip: 'Dashboard',
        iconKey: 'dashboard',
        route: platformRoute('dashboard-home'),
    },
    {
        id: 'process',
        label: 'Process',
        tooltip: 'Process',
        iconKey: 'process',
        route: null,
        children: [
            {
                id: 'run-reconciliation',
                label: 'Run Reconciliation',
                tooltip: 'Run Reconciliation',
                route: platformRoute('upload'),
                mode: 'run-reconciliation',
            },
            {
                id: 'create-sessions',
                label: 'Sessions',
                tooltip: 'Sessions',
                route: platformRoute('upload'),
                mode: 'create-sessions',
            },
            {
                id: 'process-files',
                label: 'Consolidation',
                tooltip: 'Consolidation',
                route: platformRoute('upload'),
                mode: 'process-files',
            },
            { id: 'erp-data', label: 'ERP Data', tooltip: 'ERP Data', route: platformRoute('erp-import-data') },
        ],
    },
    {
        id: 'documents',
        label: 'Documents',
        tooltip: 'Documents',
        iconKey: 'documents',
        route: null,
        children: [
            { id: 'results', label: 'Extract Results', tooltip: 'Extract Results', route: platformRoute('upload-results') },
            { id: 'registry', label: 'Document Registry', tooltip: 'Document Registry', route: platformRoute('registerdocuments') },
        ],
    },
    {
        id: 'automation',
        label: 'Automation',
        tooltip: 'Automation',
        iconKey: 'automation',
        route: null,
        children: [
            {
                id: 'post-process',
                label: 'Post Process',
                tooltip: 'Post Process',
                route: platformRoute('post-process'),
            },
        ],
    },
    {
        id: 'integration',
        label: 'Integration',
        tooltip: 'Integration',
        iconKey: 'integration',
        route: null,
        children: [
            { id: 'xero', label: 'Xero', tooltip: 'Xero', route: null },
            { id: 'quickbooks', label: 'QuickBooks', tooltip: 'QuickBooks', route: null },
        ],
    },
    {
        id: 'access',
        label: 'Access',
        tooltip: 'Access',
        iconKey: 'api-keys',
        route: null,
        children: [
            {
                id: 'api-keys',
                label: 'API Keys',
                tooltip: 'API Key Management',
                route: platformRoute('api-keys'),
            },
        ],
    },
    {
        id: 'configuration',
        label: 'Configuration',
        tooltip: 'Configuration',
        iconKey: 'settings',
        route: null,
        children: [
            {
                id: 'consolidation-settings',
                label: 'Consolidation',
                tooltip: 'Consolidation',
                route: platformRoute('consolidationsettings'),
            },
            {
                id: 'reconciliation-settings',
                label: 'Reconciliation',
                tooltip: 'Reconciliation',
                route: platformRoute('reconciliationsettings'),
            },
            {
                id: 'extraction-settings',
                label: 'Extraction Settings',
                tooltip: 'Extraction Settings',
                route: platformRoute('extractionsettings'),
            },
        ],
    },
];

export const LEFT_NAV_HAMBURGER_ICON_KEY = 'horizontal_lines_3';
